import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

export default function SaveFilterModal(
    props: { onCancel: () => void, onConfirm: () => void, open: boolean } = { open: false }
) {
    return (
        <Modal open={props.open} size="small">
            <Modal.Header content="Save Filter" />
            <Modal.Content content="Are you sure you want to save this filter?" />
            <Modal.Actions>
                <Button content="Cancel" onClick={props.onCancel} />
                <Button content="Save" onClick={props.onConfirm} primary />
            </Modal.Actions>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./components/molecules/SaveFilterModal.jsx